import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table4IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');


class Table4 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      ans9: false,
      ans10: false,
      name: '失眠自我診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table4',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551'
    }
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.handleChangeAns8 = this.handleChangeAns8.bind(this)
    this.handleChangeAns9 = this.handleChangeAns9.bind(this)
    this.handleChangeAns10 = this.handleChangeAns10.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is20')
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is40')
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is60')
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is80')
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    sliderBar.classList.add('is100')
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1) + (this.state.ans9 * 1) + (this.state.ans10 * 1))
    if(total < 36) {
      rootRef.update({
        Reviews: '無明顯失眠困擾，應維持良好睡眠習慣，減少失眠機會。',
        ans: total,
        name: '失眠自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table4',
        localUrl: '/Table4',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551'
      })
    } else {
      rootRef.update({
        Reviews: '明顯失眠困擾，應尋求專業協助。',
        ans: total,
        name: '失眠自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table4',
        localUrl: '/Table4',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable4.jpg?alt=media&token=4e5ea660-8237-44f4-ae31-880e686bd551'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is10')
    const toQ2 = ReactDOM.findDOMNode(this.refs.toQ2)
    scrollToComponent(toQ2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is10')
    sliderBar.classList.add('is20')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is20')
    sliderBar.classList.add('is30')
    const toQ4 = ReactDOM.findDOMNode(this.refs.toQ4)
    scrollToComponent(toQ4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is30')
    sliderBar.classList.add('is40')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is40')
    sliderBar.classList.add('is50')
    const toQ6 = ReactDOM.findDOMNode(this.refs.toQ6)
    scrollToComponent(toQ6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is50')
    sliderBar.classList.add('is60')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is60')
    sliderBar.classList.add('is70')
    const toQ8 = ReactDOM.findDOMNode(this.refs.toQ8)
    scrollToComponent(toQ8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is70')
    sliderBar.classList.add('is80')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns9(event) {
    this.setState({ans9: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is80')
    sliderBar.classList.add('is90')
    const toQ10 = ReactDOM.findDOMNode(this.refs.toQ10)
    scrollToComponent(toQ10, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns10(event) {
    this.setState({ans10: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is90')
    sliderBar.classList.add('is100')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = ((this.state.ans1 + this.state.ans2) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = ((this.state.ans3 + this.state.ans4) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = ((this.state.ans5 + this.state.ans6) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = ((this.state.ans7 + this.state.ans8) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>快完成了</div>
     : null
    const nextBtn5 = ((this.state.ans9 + this.state.ans10) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null

    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table4">
           <h1>你容易失眠嗎?</h1>
           <h2>長期失眠 等於慢性自殺</h2>
           <p className="moileNone">
           年輕時總覺得睡覺很浪費生命，<br />
           久而久之，生理時鐘被打亂...想入睡卻很難<br />
           睡眠不是種浪費，而是健康的必備元素
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table4'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table4'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>失眠自我診斷</h2>
            <sub>請您根據最近一星期內以來身體與情緒的真正感覺，勾選最符合的一項!</sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
             <div className="table1 isShow" ref="table1">
              <article ref="toQ2">
               <h1>Q1:最近兩周內是否入睡困難?</h1>
               <input type="radio" value='2'
                id="ans1"
                checked={this.state.ans1 === '2'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">無</label>
               <input type="radio" value='4'
                id="ans2"
                checked={this.state.ans1 === '4'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">輕微</label>
               <input type="radio" value='6'
                id="ans3"
                checked={this.state.ans1 === '6'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans3">中等</label>
               <input type="radio" value='8'
                id="ans4"
                checked={this.state.ans1 === '8'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans4">嚴重</label>
               <input type="radio" value='10'
                id="ans5"
                checked={this.state.ans1 === '10'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans5">非常嚴重</label>
              </article>
              <article ref="toNext1">
               <h1>Q2:最近兩周內睡眠品質是否很糟糕?</h1>
               <input type="radio" value='2'
                id="ans6"
                checked={this.state.ans2 === '2'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans6">無</label>
               <input type="radio" value='4'
                id="ans7"
                checked={this.state.ans2 === '4'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans7">輕微</label>
               <input type="radio" value='6'
                id="ans8"
                checked={this.state.ans2 === '6'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans8">中等</label>
               <input type="radio" value='8'
                id="ans9"
                checked={this.state.ans2 === '8'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans9">嚴重</label>
               <input type="radio" value='10'
                id="ans10"
                checked={this.state.ans2 === '10'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans10">非常嚴重</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toQ4">
               <h1>Q3:最近兩周內是否有異常驚醒的狀況?</h1>
               <input type="radio" value='2'
                id="ans11"
                checked={this.state.ans3 === '2'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans11">無</label>
               <input type="radio" value='4'
                id="ans12"
                checked={this.state.ans3 === '4'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans12">輕微</label>
               <input type="radio" value='6'
                id="ans13"
                checked={this.state.ans3 === '6'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans13">中等</label>
               <input type="radio" value='8'
                id="ans14"
                checked={this.state.ans3 === '8'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans14">嚴重</label>
               <input type="radio" value='10'
                id="ans15"
                checked={this.state.ans3 === '10'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans15">非常嚴重</label>
              </article>
              <article ref="toNext2">
               <h1>Q4:是否滿意最近兩周內的睡眠品質?</h1>
               <input type="radio" value='2'
                id="ans16"
                checked={this.state.ans4 === '2'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans16">非常滿意</label>
               <input type="radio" value='4'
                id="ans17"
                checked={this.state.ans4 === '4'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans17">滿意</label>
               <input type="radio" value='6'
                id="ans18"
                checked={this.state.ans4 === '6'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans18">尚可</label>
               <input type="radio" value='8'
                id="ans19"
                checked={this.state.ans4 === '8'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans19">不滿意</label>
               <input type="radio" value='10'
                id="ans20"
                checked={this.state.ans4 === '10'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans20">非常不滿意</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toQ6">
               <h1>Q5:睡眠問題是否有干擾到您的日常生活功能?</h1>
               <input type="radio" value='2'
                id="ans21"
                checked={this.state.ans5 === '2'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans21">無</label>
               <input type="radio" value='4'
                id="ans22"
                checked={this.state.ans5 === '4'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans22">輕微</label>
               <input type="radio" value='6'
                id="ans23"
                checked={this.state.ans5 === '6'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans23">中等</label>
               <input type="radio" value='8'
                id="ans24"
                checked={this.state.ans5 === '8'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans24">嚴重</label>
               <input type="radio" value='10'
                id="ans25"
                checked={this.state.ans5 === '10'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans25">非常嚴重</label>
              </article>
              <article ref="toNext3">
               <h1>Q6:我擔心不能睡好?</h1>
               <input type="radio" value='2'
                id="ans26"
                checked={this.state.ans6 === '2'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans26">無</label>
               <input type="radio" value='4'
                id="ans27"
                checked={this.state.ans6 === '4'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans27">輕微</label>
               <input type="radio" value='6'
                id="ans28"
                checked={this.state.ans6 === '6'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans28">中等</label>
               <input type="radio" value='8'
                id="ans29"
                checked={this.state.ans6 === '8'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans29">嚴重</label>
               <input type="radio" value='10'
                id="ans30"
                checked={this.state.ans6 === '10'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans30">非常嚴重</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toQ8">
               <h1>Q7:是否需要一個小時或以上才睡得著?</h1>
               <input type="radio" value='2'
                id="ans31"
                checked={this.state.ans7 === '2'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans31">從來不會</label>
               <input type="radio" value='4'
                id="ans32"
                checked={this.state.ans7 === '4'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans32">很少</label>
               <input type="radio" value='6'
                id="ans33"
                checked={this.state.ans7 === '6'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans33">偶爾</label>
               <input type="radio" value='8'
                id="ans34"
                checked={this.state.ans7 === '8'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans34">經常</label>
               <input type="radio" value='10'
                id="ans35"
                checked={this.state.ans7 === '10'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans35">一直都是</label>
              </article>
              <article ref="toNext4">
               <h1>Q8:是否夜間會醒來三次或以上?</h1>
               <input type="radio" value='2'
                id="ans36"
                checked={this.state.ans8 === '2'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans36">從來不會</label>
               <input type="radio" value='4'
                id="ans37"
                checked={this.state.ans8 === '4'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans37">很少</label>
               <input type="radio" value='6'
                id="ans38"
                checked={this.state.ans8 === '6'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans38">偶爾</label>
               <input type="radio" value='8'
                id="ans39"
                checked={this.state.ans8 === '8'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans39">經常</label>
               <input type="radio" value='10'
                id="ans40"
                checked={this.state.ans8 === '10'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans40">一直都是</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toQ10">
               <h1>Q9:是否需要藉助酒精幫助入睡?</h1>
               <input type="radio" value='2'
                id="ans41"
                checked={this.state.ans9 === '2'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans41">從來不用</label>
               <input type="radio" value='4'
                id="ans42"
                checked={this.state.ans9 === '4'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans42">很少</label>
               <input type="radio" value='6'
                id="ans43"
                checked={this.state.ans9 === '6'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans43">偶爾</label>
               <input type="radio" value='8'
                id="ans44"
                checked={this.state.ans9 === '8'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans44">經常</label>
               <input type="radio" value='10'
                id="ans45"
                checked={this.state.ans9 === '10'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans45">一直都是</label>
              </article>
              <article ref="toNext5">
               <h1>Q10:是否覺得不管睡多久都還是很累?</h1>
               <input type="radio" value='2'
                id="ans46"
                checked={this.state.ans10 === '2'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans46">從來不會</label>
               <input type="radio" value='4'
                id="ans47"
                checked={this.state.ans10 === '4'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans47">很少</label>
               <input type="radio" value='6'
                id="ans48"
                checked={this.state.ans10 === '6'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans48">偶爾</label>
               <input type="radio" value='8'
                id="ans49"
                checked={this.state.ans10 === '8'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans49">經常</label>
               <input type="radio" value='10'
                id="ans50"
                checked={this.state.ans10 === '10'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans50">一直都是</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table4;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#3cb4e6'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table4.js